import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import VeiculoViagemDashboard from "model/gestao/frotas/dashboard/VeiculoViagemDahboard";
import VeiculoViagemDashboardFilters from "model/gestao/frotas/dashboard/VeiculoViagemDashboardFilters";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useState } from "react";
import VeiculoViagemDashboardService from "service/gestao/frotas/VeiculoViagemDashboardService";
import { VictoryAxis, VictoryBar, VictoryChart, VictoryTheme, VictoryVoronoiContainer } from "victory";

const hoje = new Date();

const inicioMes = new Date(hoje.getFullYear(), hoje.getMonth(), 1, 0, 0, 0);
const fimMes = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0, 23, 59, 59);

const service = new VeiculoViagemDashboardService();
export default function VeiculoViagemDashboardPage() {

    const [filters, setFilters] = useState<VeiculoViagemDashboardFilters>(new VeiculoViagemDashboardFilters(inicioMes, fimMes));
    const [dados, setDados] = useState<VeiculoViagemDashboard | null>(null);

    useEffect(() => {
        service.getDashboard(filters)
            .then(response => setDados(response))
            .catch(err => console.error(err));
    }, [filters])

    const Indicador = (titulo: string, subtitulo: string, value: string, icon: IconProp, color: string) => {
        return <div style={{ display: "flex", width: "20%", padding: 16, borderRadius: 4, border: "1px solid #B2B2B2", justifyContent: "space-between", alignItems: "center" }}>
            <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                <label style={indicadorStyles.titulo}>{titulo}</label>
                <label style={indicadorStyles.value}>{value}</label>
                <label style={indicadorStyles.subtitulo}>{subtitulo}</label>
            </div>
            <FontAwesomeIcon icon={icon} size="2x" color={color} />
        </div>
    }
    const formatarNome = (nome: string) => {
        return nome.length > 12 ? nome.slice(0, 12) + "..." : nome;
    };
    const dadosGrafico = dados?.graficoQuilometrosPorMotorista?.bars.map((dado) => {
        return {
            name: formatarNome(dado.name),
            y: dado.y
        }
    }) || [];

    const larguraPorItem = 50; // controla espaçamento total (barra + gap)
    const larguraGrafico = Math.max(dadosGrafico.length * larguraPorItem, 400);


    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            <label style={styles.titulo}>Dashboard de Viagens de veículos</label>
            <label style={styles.subtitulo}>Acompanhe métricas e indicadoes das viagens da sua frota</label>

            <div style={{ display: 'flex', gap: 8, marginTop: 16, alignItems: 'center' }}>
                <label style={styles.labelPeriodo}>Período</label>
                <DatePicker
                    value={dayjs(filters.inicioPeriodo)}
                    onChange={(value) => setFilters({ ...filters, inicioPeriodo: value?.startOf("day").toDate() || null })} />
                <label style={styles.labelPeriodo}>até</label>
                <DatePicker
                    value={dayjs(filters.fimPeriodo)}
                    onChange={(date) => setFilters({ ...filters, fimPeriodo: date?.endOf("day").toDate() || null })}
                />
            </div>

            <div style={{ display: "flex", gap: "1%", flexWrap: "wrap" }}>
                {Indicador("Total de Quilômetros", "no período", `${(dados?.totalQuilometrosPercorridos || 0).toFixed(2).replace(".", ",")} km`, "location-dot", "#4d84fc")}
                {Indicador("Total de tempo percorrido", "no período", dados?.totalTempoPercorrido || "0", "clock", "#48742c")}
                {Indicador("Total de viagens", "no período", dados?.totalDeViagens.toString() || "0", "route", "#ad40fb")}
                {Indicador("Motoristas", "operaram no período", `${dados?.numeroDeMotoristas || 0}`, "car", "#f7733b")}
            </div>
            <div style={{ display: "flex", gap: "1%", flexWrap: "wrap" }}>
                <div style={{ display: "flex", flexDirection: "column", width: "41%", borderRadius: 4, border: "1px solid #B2B2B2", justifyContent: "space-between", gap: 8 }}>
                    <label style={{ margin: 16, color: "#717192" }}>Quilômetros por Motorista</label>
                    {dados?.graficoQuilometrosPorMotorista ? <VictoryChart
                        domainPadding={{ x: 50 }}
                    >
                        <VictoryAxis
                            dependentAxis
                        />

                        <VictoryAxis
                            tickFormat={dadosGrafico.map(item => item.name)}
                            style={{
                                tickLabels: {
                                    angle: -30,
                                    textAnchor: "end",
                                    fontSize: 10,
                                    padding: 2,
                                }
                            }}
                        />

                        <VictoryBar
                            data={dadosGrafico}
                            x="name"
                            y="y"
                            barWidth={(larguraGrafico / dados.graficoQuilometrosPorMotorista.bars.length) - 50} // 👈 largura fixa real
                            style={{
                                data: {
                                    fill: "#4f46e5",
                                    borderRadius: 4
                                }
                            }}
                            labels={({ datum }) => datum.y.toFixed(2).replace(".", ",") + " km"}
                        />
                    </VictoryChart> : null}

                </div>
                <div style={{ display: "flex", flexDirection: "column", width: "41%", padding: 16, borderRadius: 4, border: "1px solid #B2B2B2", gap: 8 }}>
                    <label style={{ color: "#717192" }}>Detalhamento por Motorista</label>
                    <DataTable value={dados?.detalhamentoMotoristas || []} paginator rows={10} emptyMessage="Nenhum motorista encontrado">
                        <Column field="motorista" header="Motorista" />
                        <Column field="numeroViagens" header="Viagens" />
                        <Column field="totalQuilometros" header="Quilômetros" body={(rowData) => `${rowData.totalQuilometros.toFixed(2).replace(".", ",")} km`} />
                    </DataTable>
                </div>
            </div>

        </div>
    )

}

const styles = {
    titulo: {
        fontSize: 24,
        fontWeight: 'bold'
    },
    subtitulo: {
        fontSize: 16,
        color: "#717192"
    },
    labelPeriodo: {
        fontSize: 16,
        color: "#717192"
    }

};

const indicadorStyles = {
    titulo: {
        fontSize: 14,
        color: "#717192"
    },
    subtitulo: {
        fontSize: 12,
        color: "#717192"
    },
    value: {
        fontSize: 20,
    }
}